import Excerpt from './Excerpt';
export const components = {
  Excerpt
};
flarum.reg.add('lcoy-synopsis', 'forum/components', null);